<p-toast />
<main class="pb-[25vh]">
  <div class="flex flex-col gap-y-[8px] mb-[24px]">
    <lib-breadcrumb [items]="items" />
    <h1 class="heading-24 font-medium flex items-center gap-x-[14px]">
      <span>{{ selectedFdpSubmmitProject }}</span>
      <lib-status-chip [status]="fdpSubmissionRequestStatus" [statusType]="chipStatusType" class="inline-flex">{{
        fdpSubmissionRequestStatus
        }}</lib-status-chip>
    </h1>
  </div>
  <div class="flex items-start">
    <div class="flex flex-col gap-y-[24px]">
      <app-fdp-details-side-navigation [fdpSubmissionRequestStatus]="fdpSubmissionRequestStatus" />
      <lib-card classes="shadow-xs px-[20px] w-[296px]">
        <h1 class="heading-16 font-medium flex items-center">
          FDP Workflow
          <lib-information-icon classes="fill-blue-gray-500 ml-[8px]" />
        </h1>
        <lib-stepper [activeStepper]="currentStep" [options]="workflowSteps" class="min-h-[300px] h-full"></lib-stepper>
      </lib-card>
    </div>

    <div class="w-full flex flex-col gap-y-[8px] px-[24px] pt-[24px] pb-[32px] bg-white rounded-[8px] shadow-xs">
      <lib-card classes="bg-blue-gray-50 border-blue-gray-300 p-[24px]">
        <div class="flex justify-around gap-x-[8px]">
          <lib-fdp-details label="Project" class="max-w-[292px]">
            <span class="heading-14 font-medium">{{ selectedFdpSubmmitProject }}</span>
          </lib-fdp-details>
          <lib-fdp-details label="Project Type">
            <span class="heading-14 font-medium">{{ fdpProjectType }}</span>
          </lib-fdp-details>
        </div>
      </lib-card>
      <router-outlet></router-outlet>
    </div>
  </div>
</main>